import { render, staticRenderFns } from "./TimeSubmission.vue?vue&type=template&id=486c8be2&scoped=true&"
import script from "./TimeSubmission.vue?vue&type=script&lang=js&"
export * from "./TimeSubmission.vue?vue&type=script&lang=js&"
import style0 from "./TimeSubmission.vue?vue&type=style&index=0&id=486c8be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c8be2",
  null
  
)

export default component.exports